import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import WidgetWrapper from "./WidgetWrapper";
/**
 * @deprecated
 * This widget will give a simple widget with configurable option to create a link button
 *
 * @example
 * ```
 *  <LinkButtonWidget
 *      link="https://google.com"
 *      target="_blank"
 *      icon="path to your icon"
 *      label="Go to Google"
 *  />
 * ```
 * @export
 */
const LinkButtonWidget = (props) => {
    let { link, icon, target = '_self', label } = props;
    return (_jsx(WidgetWrapper, { className: "link-btn-widget-cont", children: _jsx("a", { href: link, target: target, className: "link", children: _jsxs("div", { className: "icon-container", children: [_jsx("img", { src: icon, alt: "link-btn-icon" }), _jsx("div", { className: "text", children: label })] }) }) }));
};
export default LinkButtonWidget;
